import { Environment } from '../Environment';

/**
 * Just being lazy -- formats data and logs it nicely :)
 */
export const logPrintableResult = (data: any) => {
  const { services: sv } = Environment.current();

  const printableResult = JSON.stringify(data, undefined, 4);
  sv.logger.log(`[!] [RESULT] json -`, printableResult);
};
